// Single cache instance to reuse through out the app
import { SimpleCache } from "react-fetch-component";
export const cache = new SimpleCache();
